"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const BeCropReport_1 = __importDefault(require("@becrop/components/Results/Abstract/Models/BeCropReport"));
const Report_1 = __importDefault(require("@becrop/components/Results/Abstract/Models/Report"));
const ParcelShape_vue_1 = __importDefault(require("@becrop/components/Common/ParcelShape.vue"));
const floating_vue_1 = require("floating-vue");
const ModalEditionReports_vue_1 = __importDefault(require("@becrop/components/Results/Reports/ModalEditionReports.vue"));
const ReportExpanded_vue_1 = __importDefault(require("@becrop/components/Results/ReportExpanded.vue"));
const SingleReportController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/SingleReportController"));
let TableReportList = class TableReportList extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.biome = true;
        this.distribute = true;
        this.format = [20, 20, 20, 25, 30, 30, 10, 10, 20, 0];
        this.isEditionModalActive = false;
        this.editedReport = new Report_1.default({});
        this.pendingAssignedReports = [];
        this.assigningReportId = -1;
        this.assigningResponseType = '';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    deployEditionModal(r) {
        let filledReport = new Report_1.default(r);
        this.editedReport = filledReport;
        this.isEditionModalActive = true;
    }
    dismissEditionModal() {
        this.isEditionModalActive = false;
    }
    chooseSortable(c) {
        this.$emit('updateSortable', c);
    }
    notifySuccessfulEdition() {
        this.$emit('notifysuccessfuledition');
    }
    downloadReport(code) {
        window.location.href = '/report/pdf/' + code;
    }
    anonymizeReport(code) {
        window.location.href = '/report/pdf/' + code + '?anonymize=true';
    }
    parseReport(ix) {
        const currentReport = this.reports[ix].becrop_report;
        let convertedReport = new BeCropReport_1.default(Object.assign(Object.assign({}, currentReport), { shi_rank: this.reports[ix].becrop_report_shi.rank }));
        return convertedReport;
    }
    launchProject(p) {
        //TODO:
        //console.log('launch project');
    }
    seeProposal(p) {
        //TODO:
        //console.log('see proposal');
    }
    insertInPendingAssignments(a, b) {
        if (this.pendingAssignedReports.findIndex((a) => a.reportId === b) === -1) {
            this.pendingAssignedReports.push({
                'reportId': b,
                'parcelId': a.value
            });
        }
    }
    async assignReportToParcel(reportId) {
        this.assigningReportId = reportId;
        const pendAssign = this.pendingAssignedReports.find((pa) => pa.reportId === reportId);
        const singleReportService = new SingleReportController_1.default({ 'id': reportId });
        const resp = await singleReportService.assignReportToParcel(reportId, pendAssign.parcelId);
        if (resp.status === true) {
            // eslint-disable-next-line
            let vm = this;
            this.assigningResponseType = 'ok';
            setTimeout(function () {
                vm.assigningReportId = -1;
                vm.pendingAssignedReports = vm.pendingAssignedReports.filter((pa) => pa.reportId !== reportId);
                vm.assigningResponseType = '';
            }, 1000);
            this.$emit('updateReports', reportId, pendAssign.parcelId);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TableReportList.prototype, "reports", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableReportList.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableReportList.prototype, "theadElements", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableReportList.prototype, "parcelsAvailable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableReportList.prototype, "phaseOccupacySelector", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableReportList.prototype, "textSearch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TableReportList.prototype, "cropActived", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TableReportList.prototype, "locale", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableReportList.prototype, "criteria", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TableReportList.prototype, "direction", void 0);
TableReportList = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'TableReportList',
        components: {
            TableHeader: bmk_ui_framework_1.TableHeader,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            Select: bmk_ui_framework_1.Select,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            DateStylized: bmk_ui_framework_1.DateStylized,
            ViewZero: bmk_ui_framework_1.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon,
            CrossIcon: bmk_ui_framework_1.CrossIcon,
            Modal: bmk_ui_framework_1.Modal,
            Loader: bmk_ui_framework_1.Loader,
            ShipmentIcon: bmk_ui_framework_1.ShipmentIcon,
            Button: bmk_ui_framework_1.Button,
            Toasts: bmk_ui_framework_1.Toasts,
            Tag: bmk_ui_framework_1.Tag,
            ReportExpanded: ReportExpanded_vue_1.default,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            Edit2: lucide_vue_next_1.Edit2,
            Save: lucide_vue_next_1.Save,
            Glasses: lucide_vue_next_1.Glasses,
            GroupAreas: bmk_ui_framework_1.GroupAreas,
            ParcelShape: ParcelShape_vue_1.default,
            Dropdown: floating_vue_1.Dropdown,
            ModalEditionReports: ModalEditionReports_vue_1.default,
        },
    })
], TableReportList);
exports.default = TableReportList;
